<template>
    <div class="table">
        <div class="container">
            <el-tabs type="border-card">
                <el-tab-pane label="SSR基础信息">
                    <ssr-manage-add/>
                </el-tab-pane>
                <el-tab-pane label="供应商Proposal">
                    <supplier-pane/>
                </el-tab-pane>
                <el-tab-pane label="报价信息PQCP">
                    <offer-info-pane/>
                </el-tab-pane>
                <el-tab-pane label="成本结构">
                    <cose-info-pane/>
                </el-tab-pane>
                <el-tab-pane label="产能信息">
                    <production-info-pane/>
                </el-tab-pane>
                <el-tab-pane label="物流能力">
                    <logistics-pane/>
                </el-tab-pane>
                <el-tab-pane label="SPM评分">
                    <spm-core-pane/>
                </el-tab-pane>
                <el-tab-pane label="状态变更日志">

                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>
<script>
    import router from '../../../router';
    import {apiService} from "@/api/ssr-manage/ssr-manage";
    import {Message} from "element-ui";
    import commonMethods from "@/utils/commonMethods";
    import ssrManageAdd from "@/components/page/ssr-manage/ssr-manage-add";
    import supplierPane from "@/components/page/ssr-manage/supplier-pane";
    import offerInfoPane from "@/components/page/ssr-manage/offer-info-pane";
    import coseInfoPane from "@/components/page/ssr-manage/cost-info-pane";
    import productionInfoPane from "@/components/page/ssr-manage/production-info-pane";
    import logisticsPane from "@/components/page/ssr-manage/logistics-pane";
    import spmCorePane from "@/components/page/ssr-manage/spm-core-pane";

    export default {
        name: 'ssr-detail-load',
        extends: commonMethods,
        components: {
            ssrManageAdd,
            supplierPane,
            offerInfoPane,
            coseInfoPane,
            productionInfoPane,
            logisticsPane,
            spmCorePane
        },
        data() {
            return {
                formData: {
                    supplierCode: '',
                    supplierName: '',
                    address: '',
                },
                labelPosition: 'right',
            }
        },
        created() {
        },
        methods: {
            /*点击供应商列表中的供应商名称进入的页面，可查看单个供应商的详情，但不能编辑。也可下载PQCP、产能等Excel表格和供应商上传的附件。*/
        }
    }
</script>
<style scoped>
</style>
